import { SVGProps } from 'react';

const Webflow = ({
  isDark = false,
  props,
}: {
  isDark?: boolean;
  props?: SVGProps<SVGSVGElement>;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="84" height="53" viewBox="0 0 84 53" fill="none" {...props}>
    <path
      fill={isDark ? '#136CEF ' : '#fff'}
      fillRule="evenodd"
      d="M83.917 0 57.14 52.25H31.989l11.206-21.655h-.503C33.447 42.575 19.654 50.46 0 52.25V30.895s12.573-.741 19.964-8.498H0V0h22.438v18.421l.503-.002L32.111 0h16.968v18.305l.504-.001L59.096 0h24.82Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Webflow;
